import BancoReginalSergipe from './banco-regional-sergipe'
import BancoRegionalBrasilia from './banco-regional-brasilia'
import BanestesValidator from './banco-estado-espirito-santo'
import SicrediValidator from './banco-sicredi'
import BanparaValidator from './banco-estado-para'

(function(window) {
  var ArautosBanks = window.ArautosBanks || {};
  window.ArautosBanks = ArautosBanks;

  function BankAccount() {
    if ( !( this instanceof BankAccount ) ) {
      return new BankAccount();
    }
  }

  BankAccount.prototype = {

    validator: function (bankNumber) {
      var validators = {
        "047": BancoReginalSergipe,
        "070": BancoRegionalBrasilia,
        "021": BanestesValidator,
        "748": SicrediValidator,
        "037": BanparaValidator
      };

      if (validators[bankNumber]) {
        return validators[bankNumber];
      } else {
        return null
      }
    },

    validate: function (params){
      var errors = [];
      var validator = this.validator(params.bankNumber);

      if(!validator){
        errors.push({ description: "Banco inválido", code: "INVALID_BANK_NUMBER" });
      }

      if(!validator.agencyNumberIsValid(params.agencyNumber)){
        errors.push({ description: validator.agencyNumberMsgError(), code: "INVALID_AGENCY_NUMBER" });
      }

      if(!validator.agencyCheckNumberIsValid(params.agencyCheckNumber)){
        errors.push({ description: validator.agencyCheckNumberMsgError(), code: "INVALID_AGENCY_CHECK_NUMBER" });
      }

      if(!validator.accountNumberIsValid(params.accountNumber)){
        errors.push({ description: validator.accountNumberMsgError(validator.accountNumberLength()), code: "INVALID_ACCOUNT_NUMBER" });
      }

      if(!validator.accountCheckNumberIsValid(params.accountCheckNumber)){
        errors.push({ description: "Dígito da conta corrente inválido", code: "INVALID_ACCOUNT_CHECK_NUMBER" });
      }

      if(validator.agencyNumberIsValid(params.agencyNumber) && validator.agencyCheckNumberIsValid(params.agencyCheckNumber)){
        if(!validator.agencyCheckNumberMatch(params)) {
          errors.push({ description: "Dígito da agência não corresponde ao número da agência preenchido", code: "AGENCY_CHECK_NUMBER_DONT_MATCH" });
        }
      }

      if(validator.accountNumberIsValid(params.accountNumber) && validator.accountCheckNumberIsValid(params.accountCheckNumber)){
        if(!validator.accountCheckNumberMatch(params)) {
          errors.push({ description: "Dígito da conta não corresponde ao número da conta/agência preenchido", code: "ACCOUNT_CHECK_NUMBER_DONT_MATCH" });
        }
      }

      if(errors.length === 0) {
        params.valid();
      } else {
        params.invalid({ errors: errors });
      }
    }

  };

  ArautosBanks.BankAccount = BankAccount();

})(window);


// WEBPACK FOOTER //
// ./src/assets/js/arautos-bank-validator/index.js